import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import { Select } from 'antd';
import { getOrganizationList } from './graphql';

const { Option } = Select;

export default function ViewMessagesHOC(ViewMessages) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,

        jwtToken: PropTypes.string.isRequired,
        expiration: PropTypes.number.isRequired,
        organizationId: PropTypes.string.isRequired,
        role: PropTypes.string.isRequired,
      }).isRequired,
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
      }).isRequired,

      saveDraft: PropTypes.func.isRequired,
      activeDraft: PropTypes.string.isRequired,
      onChangeDraft: PropTypes.func.isRequired,
      deleteDraft: PropTypes.func.isRequired,
      addMessage: PropTypes.func.isRequired,
      conversationMessages: PropTypes.object.isRequired,
      setCurrentRecipients: PropTypes.func.isRequired,
      setTitle: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
      onCompose: PropTypes.func.isRequired,
      currentRecipients: PropTypes.any.isRequired,
      handleUpload: PropTypes.func.isRequired,
      onRemove: PropTypes.func.isRequired,
      onSubmit: PropTypes.func.isRequired,
      fileList: PropTypes.any.isRequired,
      handleUploadChange: PropTypes.func.isRequired,
      submitting: PropTypes.bool.isRequired,
    };

    static initialState = {
      fileList: [],
      uploading: false,
      attachmentNames: [],
      organizationList: null,
      organizationNameList: null,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const listOfOrgNames = [];
      let res = await getOrganizationList();
      console.log(res);
      if (!res) {
        res = {};
      }
      console.log(res.length);
      const orgList = sortBy([...res], 'name');
      console.log(orgList);

      const uniqueOrgs = uniqBy(orgList, 'cageCode');

      /* eslint-disable consistent-return */
      /* eslint-disable array-callback-return */
      const arr = uniqueOrgs.map(organization => {
        if (!organization.name || !organization.cageCode) {
          console.log('here');
          return;
        }
        // return 'here';
        if (organization.cageCode !== 'O0000') {
          listOfOrgNames.push(
            organization.name.replace(/[^A-Z0-9]/gi, '').toLowerCase(),
          );
          return (
            <Option key={organization.cageCode} value={organization.cageCode}>
              {organization.name}
            </Option>
          );
        }
        // /  return <Option />;
      });

      this.setState({
        organizationList: new Set(arr),
        organizationNameList: listOfOrgNames,
      });
    }

    render() {
      const { uploading, organizationList, organizationNameList } = this.state;
      const {
        auth,
        saveDraft,
        activeDraft,
        onChangeDraft,
        deleteDraft,
        conversationMessages,
        setCurrentRecipients,
        setTitle,
        title,
        currentRecipients,
        onSubmit,
        onRemove,
        handleUpload,
        submitting,
        fileList,
        handleUploadChange,
      } = this.props;
      const pageProps = {
        fileList,
        currentRecipients,
        setCurrentRecipients,
        organizationNameList,
        organizationList,
        uploading,
        auth,
        conversationMessages,
        saveDraft,
        activeDraft,
        onChangeDraft,
        setTitle,
        title,
        deleteDraft,
        onSubmit,
        handleUpload,
        onRemove,
        submitting,
        handleUploadChange,
      };
      return <ViewMessages {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/ComposeMessage/ComposeMessagesHOC.jsx